import { render, staticRenderFns } from "./KgjtWebsiteExpertsInfo.vue?vue&type=template&id=7ead783c&scoped=true&"
import script from "./KgjtWebsiteExpertsInfo.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteExpertsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead783c",
  null
  
)

export default component.exports